module.exports = __webpack_public_path__ + "static/barCode-49054144f3f016e5b79d71e01721e3c6.jpg";